import { getPinUnlockLocation, isPinUnlockRoute, useAccessStore, useAuth } from '~/entities/auth'
import { frontendPermissions, permissions, useNotificationStore } from '~/shared/lib'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { notify } = useNotificationStore()
  const {
    isAuthenticated,
    ensureValidAccessToken,
    shouldRequirePinUnlock,
    syncLoginCodeFlagIfNeeded,
  } = useAuth()
  const { can, fetchBackPermissions } = useAccessStore()
  const nextRouteName = to.name as string

  if (!isAuthenticated.value) {
    return navigateTo({
      name: permissions.AUTH.SIGNIN.PERMISSION,
      query: { redirect: to.fullPath },
    })
  }

  await syncLoginCodeFlagIfNeeded()

  if (shouldRequirePinUnlock()) {
    if (isPinUnlockRoute(to.path)) {
      return
    }

    return navigateTo(getPinUnlockLocation({
      fullPath: to.fullPath,
    }), { replace: true })
  }

  const hasValidAccessToken = await ensureValidAccessToken()

  if (!hasValidAccessToken) {
    if (shouldRequirePinUnlock()) {
      return navigateTo(getPinUnlockLocation({
        fullPath: to.fullPath,
      }), { replace: true })
    }

    return navigateTo({
      name: permissions.AUTH.SIGNIN.PERMISSION,
      query: { redirect: to.fullPath },
    })
  }

  if (to.name !== from.name) {
    try {
      await fetchBackPermissions(to)
    }
    catch (error) {
      console.error('[auth] fetchBackPermissions failed', error)
    }
  }

  if (!can(nextRouteName, null, Boolean(frontendPermissions[nextRouteName]))) {
    notify({
      message: 'У вас недостаточно прав',
      type: 'warning',
    })

    if (from.name === permissions.AUTH.SIGNIN.PERMISSION) {
      return navigateTo(permissions.WORKSPACE.ROUTE)
    }

    return navigateTo(permissions.FORBIDDEN.ROUTE)
  }
})
